// 分身商后台菜单工具
//
// 菜单的唯一权威来源是后端：后端按当前账号的角色权限过滤后返回 menus
// （未绑定角色的超级管理员由后端返回全部菜单）。
// 这里的 defaultMenus 仅作为「超级管理员」在接口异常时的安全网，
// 已分配角色但角色没勾选「首页数据」这类情况的账号绝不能用它兜底，
// 否则无权限的账号依然会看到首页等全部菜单。

export const defaultMenus = [
  { id: 1, name: '首页数据', path: '/dashboard', icon: 'el-icon-s-data', children: [] },
  { id: 2, name: '商品管理', path: '/products', icon: 'el-icon-goods', children: [] },
  { id: 3, name: '订单管理', path: '/orders', icon: 'el-icon-tickets', children: [] },
  { id: 4, name: '售后管理', path: '/after-sales', icon: 'el-icon-service', children: [] },
  { id: 5, name: '托管商品', path: '/cloud-warehouse', icon: 'el-icon-box', children: [] },
  { id: 6, name: '本域会员', path: '/members', icon: 'el-icon-user-solid', children: [] },
  { id: 7, name: '财务资产', path: '/finance', icon: 'el-icon-money', children: [] },
  { id: 8, name: '提现申请', path: '/withdraw', icon: 'el-icon-bank-card', children: [] },
  { id: 9, name: '轮播图管理', path: '/banners', icon: 'el-icon-picture', children: [] },
  { id: 10, name: '分身商设置', path: '/settings', icon: 'el-icon-setting', children: [] },
  {
    id: 100, name: '系统管理', path: '/system', icon: 'el-icon-setting', children: [
      { id: 101, name: '管理员管理', path: '/system/admins', icon: 'el-icon-user', children: [] },
      { id: 102, name: '角色管理', path: '/system/roles', icon: 'el-icon-s-custom', children: [] },
      { id: 103, name: '权限管理', path: '/system/permissions', icon: 'el-icon-lock', children: [] }
    ]
  }
]

/**
 * 决定实际渲染的菜单
 * @param {Array} menus 后端返回的菜单
 * @param {Boolean} isSuper 是否未绑定角色的超级管理员
 */
export function normalizeMenus(menus, isSuper) {
  if (menus && menus.length > 0) {
    return menus
  }
  return isSuper ? defaultMenus : []
}

/**
 * 深度优先取第一个有权限的菜单路径
 *
 * 用于「登录成功后」和「访问根路径」时的落地页：
 * 不能固定跳 /dashboard，否则角色没勾「首页数据」也会直接进首页。
 *
 * @param {Array} menus 后端返回的菜单
 * @param {Boolean} isSuper 是否未绑定角色的超级管理员
 * @returns {String} 路径，没有可访问菜单时返回空串
 */
export function firstAccessiblePath(menus, isSuper) {
  const walk = (nodes) => {
    let result = ''
    ;(nodes || []).forEach((node) => {
      if (result) return
      if (node.children && node.children.length > 0) {
        result = walk(node.children)
      }
      if (!result && node.path) {
        result = node.path
      }
    })
    return result
  }

  return walk(normalizeMenus(menus, isSuper))
}
